import { calculatedParamsMiddleware, fetchTargets, IAdFoxParams, mergeMiddlewares } from '@cian/adfox';
import { IAdFoxBannerOnLoadData } from '@cian/adfox-component';
import * as React from 'react';
import { LazyLoad } from '../LazyLoad';
import { parseAdfoxParams } from '../../utils/adfox';
import { useApplicationContext } from '../../utils/applicationContext';
import { AdfoxBanner } from '../AdfoxBanner';
import { TAdFoxTemplateType } from '../AdfoxBanner/components/OwnTemplates';
import { useBackgroundContext } from '../BackgroundProvider';
import { typeParamsMiddleware } from './middlewares';

const adfoxMiddleware = (type: TAdFoxTemplateType) => {
  return mergeMiddlewares(
    calculatedParamsMiddleware(),
    fetchTargets('apps', {
      baseUrl: `//${window.location.host}/`,
      section_type: 10,
    }),
    typeParamsMiddleware(type),
  );
};

interface IAdfoxProps {
  type: TAdFoxTemplateType;
  onLoad?: () => void;
  onBannerClick?: () => void;
  minHeight: string;
}

export const Adfox: React.FC<IAdfoxProps> = ({ type, onLoad, onBannerClick, minHeight }) => {
  const { logger } = useApplicationContext();
  const [, setBackgroundImg] = useBackgroundContext();

  const onBannerError = React.useCallback(
    (error: Error) => {
      logger.error(error, {
        message: 'Failed to render adfox banner',
        domain: 'AdfoxNew',
      });
    },
    [logger],
  );

  const onBannerLoad = React.useCallback(
    (context: IAdFoxBannerOnLoadData) => {
      if (onLoad) {
        onLoad();
      }

      const params = parseAdfoxParams(context);

      if (params) {
        setBackgroundImg(params.bgImageUrl);
      }
    },
    [onLoad, setBackgroundImg],
  );

  const onComponentLoad = React.useCallback(() => {
    return adfoxMiddleware(type);
  }, [type]);

  return (
    <LazyLoad
      offset={300}
      onLoad={onComponentLoad}
      renderLoaded={(result: IAdFoxParams) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { pr, pr1, ...rest } = result;

        return (
          <div onClick={onBannerClick}>
            <AdfoxBanner
              ownerId={202100}
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              params={rest as any}
              onLoad={onBannerLoad}
              onRenderError={onBannerError}
              width="100%"
              minHeight={minHeight}
            />
          </div>
        );
      }}
      renderEmpty={() => {
        return <div />;
      }}
    />
  );
};
